<template>
<Layout>
    <div class="checkout">
        <div class="checkout__wrapper">
            <form class="checkout__form">
                <h4 class="checkout__subheading">
                    Customer information
                </h4>
                <label class="checkout__label" for="firstName">First name</label>
                <input class="checkout__input" type="text" v-model="form.customer.firstName" name="firstName" placeholder="Enter your first name" required />

                <label class="checkout__label" for="lastName">Last name</label>
                <input class="checkout__input" type="text" v-model="form.customer.lastName" name="lastName" placeholder="Enter your last name" required />

                <label class="checkout__label" for="email">Email</label>
                <input class="checkout__input" type="text" v-model="form.customer.email" name="email" placeholder="Enter your email" required />

                <h4 class="checkout__subheading">Shipping details</h4>

                <label class="checkout__label" for="fullname">Full name</label>
                <input class="checkout__input" type="text" v-model="form.shipping.name" name="name" placeholder="Enter your shipping full name" required />

                <label class="checkout__label" for="street">Street address</label>
                <input class="checkout__input" type="text" v-model="form.shipping.street" name="street" placeholder="Enter your street address" required />

                <label class="checkout__label" for="city">City</label>
                <input class="checkout__input" type="text" v-model="form.shipping.city" name="city" placeholder="Enter your city" required />

                <label class="checkout__label" for="postalZipCode">Postal/Zip code</label>
                <input class="checkout__input" type="text" v-model="form.shipping.postalZipCode" name="postalZipCode" placeholder="Enter your postal/zip code" required />

                <label class="checkout__label" for="country">Country</label>
                <select v-model="form.shipping.country" name="country" class="checkout__select">
                    <option value="" disabled>Country</option>
                    <option v-for="(country, index) in countries" :value="index" :key="index">{{ country }}</option>
                </select>

                <label class="checkout__label" for="stateProvince">State/province</label>
                <select v-model="form.shipping.stateProvince" name="stateProvince" class="checkout__select">
                    <option class="checkout__option" value="" disabled>State/province</option>
                    <option v-for="(subdivision, index) in shippingSubdivisions" :value="index" :key="index">{{ subdivision }}</option>
                </select>

                <label class="checkout__label" for="shippingOption">Shipping method</label>
                <select v-model="form.fulfillment.shippingOption" name="shippingOption" class="checkout__select">
                    <option class="checkout__select-option" value="" disabled>Select a shipping method</option>
                    <option class="checkout__select-option" v-for="(method, index) in shippingOptions" :value="method.id" :key="index">{{ `${method.description} - ${method.price.formatted_with_code}` }}</option>
                </select>

                <h4 class="checkout__subheading">Payment information</h4>

                <label class="checkout__label" for="cardNum">Credit card number</label>
                <input class="checkout__input" type="text" name="cardNum" v-model="form.payment.cardNum" placeholder="Enter your card number" />

                <label class="checkout__label" for="expMonth">Expiry month</label>
                <input class="checkout__input" type="text" name="expMonth" v-model="form.payment.expMonth" placeholder="Card expiry month" />

                <label class="checkout__label" for="expYear">Expiry year</label>
                <input class="checkout__input" type="text" name="expYear" v-model="form.payment.expYear" placeholder="Card expiry year" />

                <label class="checkout__label" for="ccv">CCV</label>
                <input class="checkout__input" type="text" name="ccv" v-model="form.payment.ccv" placeholder="CCV (3 digits)" />

                <button type="button" class="checkout__btn-confirm" :disabled="loading" @click.prevent="confirmOrder">
                    {{ loading ? 'Loading...' : 'Confirm Order' }}
                </button>
            </form>
            <div class="checkout__summary">
                <h4>Order summary</h4>
                <div v-for="lineItem in cart.line_items" :key="lineItem.id" class="checkout__summary-details">
                    <img class="checkout__summary-img" :src="lineItem.media.source" />
                    <p class="checkout__summary-name">{{ lineItem.quantity }} x {{ lineItem.name }}</p>
                    <p class="checkout__summary-value">{{ lineItem.line_total.formatted_with_symbol }}</p>
                </div>
                <div class="checkout__summary-total">
                    <p class="checkout__summary-price" v-if="liveObject && liveObject.total_due">
                        <span>Subtotal:</span>
                        {{ liveObject.total_due.formatted_with_symbol }}
                        <span>Shipping:</span>
                        {{ liveObject.shipping && liveObject.shipping.price.formatted_with_symbol}}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <section>
  <h1 class="sr-only">Checkout</h1>

  <div class="relative mx-auto max-w-screen-2xl">
    <div class="grid grid-cols-1 md:grid-cols-2">
      <div class="py-12 bg-gray-50 md:py-24">
        <div class="max-w-lg px-4 mx-auto lg:px-8">
          <div class="flex items-center">
            <span class="w-10 h-10 bg-blue-900 rounded-full"></span>

            <h2 class="ml-4 font-medium">BambooYou</h2>
          </div>

          <div class="mt-8">
            <p class="text-2xl font-medium tracking-tight">$99.99</p>
            <p class="mt-1 text-sm text-gray-500">For the purchase of</p>
          </div>

          <div class="mt-12">
            <div class="flow-root">
              <ul class="-my-4 divide-y divide-gray-200">
                <li class="flex items-center justify-between py-4">
                  <div class="flex items-start">
                    <img
                      alt="Trainer"
                      src="https://images.unsplash.com/photo-1565299999261-28ba859019bb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
                      class="flex-shrink-0 object-cover w-16 h-16 rounded-lg"
                    />

                    <div class="ml-4">
                      <p class="text-sm">Vibrant Trainers</p>

                      <dl class="mt-1 space-y-1 text-xs text-gray-500">
                        <div>
                          <dt class="inline">Color:</dt>
                          <dd class="inline">Blue</dd>
                        </div>

                        <div>
                          <dt class="inline">Size:</dt>
                          <dd class="inline">UK 10</dd>
                        </div>
                      </dl>
                    </div>
                  </div>

                  <div>
                    <p class="text-sm">
                      $49.99
                      <small class="text-gray-500">x1</small>
                    </p>
                  </div>
                </li>

                <li class="flex items-center justify-between py-4">
                  <div class="flex items-start">
                    <img
                      alt="Lettuce"
                      src="https://images.unsplash.com/photo-1640958904159-51ae08bd3412?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1771&q=80"
                      class="flex-shrink-0 object-cover w-16 h-16 rounded-lg"
                    />

                    <div class="ml-4">
                      <p class="text-sm">Lettuce</p>

                      <dl class="mt-1 space-y-1 text-xs text-gray-500">
                        <div>
                          <dt class="inline">Size:</dt>
                          <dd class="inline">Big</dd>
                        </div>
                      </dl>
                    </div>
                  </div>

                  <div>
                    <p class="text-sm">
                      $25
                      <small class="text-gray-500">x2</small>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="py-12 bg-white md:py-24">
        <div class="max-w-lg px-4 mx-auto lg:px-8">
          <form class="grid grid-cols-6 gap-4">
            <div class="col-span-3">
              <label class="block mb-1 text-sm text-gray-600" for="first_name">
                First Name
              </label>

              <input
                class="rounded-lg shadow-sm border-gray-200 w-full text-sm p-2.5"
                type="text"
                id="frst_name"
              />
            </div>

            <div class="col-span-3">
              <label class="block mb-1 text-sm text-gray-600" for="last_name">
                Last Name
              </label>

              <input
                class="rounded-lg shadow-sm border-gray-200 w-full text-sm p-2.5"
                type="text"
                id="last_name"
              />
            </div>

            <div class="col-span-6">
              <label class="block mb-1 text-sm text-gray-600" for="email">
                Email
              </label>

              <input
                class="rounded-lg shadow-sm border-gray-200 w-full text-sm p-2.5"
                type="email"
                id="email"
              />
            </div>

            <div class="col-span-6">
              <label class="block mb-1 text-sm text-gray-600" for="phone">
                Phone
              </label>

              <input
                class="rounded-lg shadow-sm border-gray-200 w-full text-sm p-2.5"
                type="tel"
                id="phone"
              />
            </div>

            <fieldset class="col-span-6">
              <legend class="block mb-1 text-sm text-gray-600">
                Card Details
              </legend>

              <div class="-space-y-px bg-white rounded-lg shadow-sm">
                <div>
                  <label class="sr-only" for="card-number">Card Number</label>

                  <input
                    class="border-gray-200 relative rounded-t-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400"
                    type="text"
                    name="card-number"
                    id="card-number"
                    placeholder="Card number"
                  />
                </div>

                <div class="flex -space-x-px">
                  <div class="flex-1">
                    <label class="sr-only" for="card-expiration-date">
                      Expiration Date
                    </label>

                    <input
                      class="border-gray-200 relative rounded-bl-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400"
                      type="text"
                      name="card-expiration-date"
                      id="card-expiration-date"
                      placeholder="MM / YY"
                    />
                  </div>

                  <div class="flex-1">
                    <label class="sr-only" for="card-cvc">CVC</label>

                    <input
                      class="border-gray-200 relative rounded-br-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400"
                      type="text"
                      name="card-cvc"
                      id="card-cvc"
                      placeholder="CVC"
                    />
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="col-span-6">
              <legend class="block mb-1 text-sm text-gray-600">
                Billing Address
              </legend>

              <div class="-space-y-px bg-white rounded-lg shadow-sm">
                <div>
                  <label class="sr-only" for="country">Country</label>

                  <select
                    class="border-gray-200 relative rounded-t-lg w-full focus:z-10 text-sm p-2.5"
                    id="country"
                    name="country"
                    autocomplete="country-name"
                  >
                    <option>England</option>
                    <option>Wales</option>
                    <option>Scotland</option>
                    <option>France</option>
                    <option>Belgium</option>
                    <option>Japan</option>
                  </select>
                </div>

                <div>
                  <label class="sr-only" for="postal-code">
                    ZIP/Post Code
                  </label>

                  <input
                    class="border-gray-200 relative rounded-b-lg w-full focus:z-10 text-sm p-2.5 placeholder-gray-400"
                    type="text"
                    name="postal-code"
                    id="postal-code"
                    autocomplete="postal-code"
                    placeholder="ZIP/Post Code"
                  />
                </div>
              </div>
            </fieldset>

            <div class="col-span-6">
              <button
                class="rounded-lg bg-black text-sm p-2.5 text-white w-full block"
                type="submit"
              >
                Pay Now
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
</Layout>
</template>

<script>
import CartItem from '../components/CartItem';
import Layout from '../components/Layout.vue';

export default {
    name: 'Checkout',
    components: {
        Layout,
        CartItem,
    },
    data() {
        return {
            form: {
                customer: {
                    firstName: 'Jane',
                    lastName: 'Doe',
                    email: 'janedoe@email.com',
                },
                shipping: {
                    name: 'Jane Doe',
                    street: '123 Fake St',
                    city: 'San Francisco',
                    stateProvince: 'CA',
                    postalZipCode: '94107',
                    country: 'US',
                },
                fulfillment: {
                    shippingOption: '',
                },
                payment: {
                    cardNum: '4242 4242 4242 4242',
                    expMonth: '01',
                    expYear: '2023',
                    ccv: '123',
                    billingPostalZipCode: '94107',
                },
            },
            liveObject: {},
            countries: {},
            shippingSubdivisions: {},
            shippingOptions: [],
            checkoutToken: null,
            loading: false
        }
    },
    async mounted() {
        if (this.checkoutToken == null) {
            if (this.cart.line_items && this.cart.line_items.length) {
                await this.generateCheckoutToken();
                this.fetchShippingCountries(this.checkoutToken.id);
                this.fetchShippingSubdivisions(this.form.shipping.country);
                this.fetchShippingOptions(this.checkoutToken.id, this.form.shipping.country, this.form.shipping.stateProvince);
                this.getLiveObject(this.checkoutToken.id);
            }
        }
    },
    computed: {
        selectedShippingOption() {
            return this.form.fulfillment.shippingOption;
        },
        selectedCountry() {
            return this.form.shipping.country;
        },
        selectedProvince() {
            return this.form.shipping.stateProvince;
        },
        cart() {
            return this.$store.getters['app/cart'] || {};
        }
    },
    watch: {
        selectedShippingOption() {
            this.validateShippingOption(this.form.fulfillment.shippingOption, this.form.shipping)
        },
        selectedCountry() {
            this.fetchShippingSubdivisions(this.form.shipping.country);
        },
        selectedProvince() {
            this.fetchShippingOptions(this.checkoutToken.id, this.form.shipping.country, this.form.shipping.stateProvince);
        },
        async cart() {
            if (this.checkoutToken == null) {
                if (this.cart.line_items && this.cart.line_items.length) {
                    await this.generateCheckoutToken();
                    this.fetchShippingCountries(this.checkoutToken.id);
                    this.fetchShippingSubdivisions(this.form.shipping.country);
                    this.fetchShippingOptions(this.checkoutToken.id, this.form.shipping.country, this.form.shipping.stateProvince);
                    this.getLiveObject(this.checkoutToken.id);
                }
            }
        }
    },
    methods: {
        /**
         * Generates a checkout token
         * https://commercejs.com/docs/sdk/checkout#generate-token
         */
        generateCheckoutToken() {
            return new Promise((resolve, reject) => {
                this.$commerce.checkout.generateToken(this.cart.id, {
                    type: 'cart'
                }).then((token) => {
                    this.checkoutToken = token;
                    resolve(token);
                }).catch((error) => {
                    console.log('There was an error in generating a token', error);
                    reject(error);
                });
            });
        },
        /**
         * Gets the live object
         * https://commercejs.com/docs/api/?javascript--cjs#get-the-live-object
         *
         * @param {string} checkoutTokenId
         */
        getLiveObject(checkoutTokenId) {
            this.$commerce.checkout.getLive(checkoutTokenId).then((liveObject) => {
                this.liveObject = liveObject;
            }).catch((error) => {
                console.log('There was an error getting the live object', error);
            });
        },
        /**
         * Fetches a list of countries available to ship to checkout token
         * https://commercejs.com/docs/sdk/checkout#list-available-shipping-countries
         *
         * @param {string} checkoutTokenId
         */
        fetchShippingCountries(checkoutTokenId) {
            this.$commerce.services.localeListShippingCountries(checkoutTokenId).then((countries) => {
                this.countries = countries.countries
            }).catch((error) => {
                console.log('There was an error fetching a list of countries', error);
            });
        },
        /**
         * Fetches the subdivisions (provinces/states) in a country which
         * can be shipped to for the current checkout
         * https://commercejs.com/docs/sdk/checkout#list-available-shipping-subdivisions
         *
         * @param {string} checkoutTokenId
         * @param {string} countryCode
         */
        fetchShippingSubdivisions(countryCode) {
            this.$commerce.services.localeListSubdivisions(countryCode).then((resp) => {
                this.shippingSubdivisions = resp.subdivisions
            }).catch((error) => {
                console.log('There was an error fetching the subdivisions', error);
            });
        },
        /**
         * Fetches the available shipping methods for the current checkout
         * https://commercejs.com/docs/sdk/checkout#get-shipping-methods
         *
         * @param {string} checkoutTokenId
         * @param {string} country
         * @param {string} stateProvince
         */
        fetchShippingOptions(checkoutTokenId, country, stateProvince) {
            this.$commerce.checkout.getShippingOptions(checkoutTokenId, {
                country: country,
                region: stateProvince
            }).then((options) => {
                this.shippingOptions = options;
            }).catch((error) => {
                console.log('There was an error fetching the shipping methods', error);
            });
        },
        /**
         * Checks and validates the shipping method
         * https://commercejs.com/docs/api/?javascript--cjs#check-shipping-method
         *
         * @param {string} shippingOptionId
         */
        validateShippingOption(shippingOptionId) {
            this.$commerce.checkout.checkShippingOption(this.checkoutToken.id, {
                shipping_option_id: shippingOptionId,
                country: this.form.shipping.country,
                region: this.form.shipping.stateProvince
            }).then((resp) => {
                this.form.fulfillment.shippingOption = resp.id;
                this.liveObject = resp.live;
            }).catch((error) => {
                console.log('There was an error setting the shipping option', error);
            })
        },
        /**
         * Emits order data to capture the order
         */
        confirmOrder() {
            const orderData = {
                line_items: this.checkoutToken.live.line_items,
                customer: {
                    firstname: this.form.customer.firstName,
                    lastname: this.form.customer.lastName,
                    email: this.form.customer.email
                },
                shipping: {
                    name: this.form.shipping.name,
                    street: this.form.shipping.street,
                    town_city: this.form.shipping.city,
                    county_state: this.form.shipping.stateProvince,
                    postal_zip_code: this.form.shipping.postalZipCode,
                    country: this.form.shipping.country,
                },
                fulfillment: {
                    shipping_method: this.form.fulfillment.shippingOption
                },
                payment: {
                    gateway: "test_gateway",
                    card: {
                        number: this.form.payment.cardNum,
                        expiry_month: this.form.payment.expMonth,
                        expiry_year: this.form.payment.expYear,
                        cvc: this.form.payment.ccv,
                        postal_zip_code: this.form.payment.billingPostalZipCode
                    }
                }
            };
            this.loading = true;
            this.handleConfirmOrder(this.checkoutToken.id, orderData);
        },
        /**
         * Captures the checkout
         * https://commercejs.com/docs/sdk/checkout#capture-order
         *
         * @param {string} checkoutTokenId The ID of the checkout token
         * @param {object} newOrder The new order object data
         */
        handleConfirmOrder(checkoutTokenId, newOrder) {
            this.$commerce.checkout.capture(checkoutTokenId, newOrder).then((order) => {
                // this.refreshCart();
                this.$store.dispatch('app/setOrder', order)
                this.$router.push('/confirmation');
                // this.isNavVisible = false;
                window.sessionStorage.setItem('order_receipt', JSON.stringify(order));
            }).catch((error) => {
                console.log('There was an error confirming your order', error);
            });
        },
    }
}
</script>

<style lang="scss">
.checkout {

    &__wrapper {
        @apply flex flex-col md:flex-row justify-center;
    }

    &__form {
        @apply w-full md:w-1/4 py-6 px-8 m-1 md:m-12 md:mt-6;
    }

    &__subheading {
        @apply text-lg font-bold;

        &:not(:first-child) {
            @apply pt-5;
        }
    }

    // &__label {
    //     @apply label;
    // }

    &__input {
        @apply w-full bg-gray-50 text-gray-800 border focus:ring ring-yellow-300 rounded outline-none transition duration-100 px-3 py-2;
    }

    &__select {
        @apply w-full max-w-xs;
    }

    &__btn-confirm {
        @apply block mt-6;

        &:disabled {
            @apply cursor-not-allowed;
        }
    }

    &__summary {
        @apply mt-6 w-full md:w-1/5 py-6 px-8;
        height: max-content;

        h4 {
            @apply font-bold;
        }
    }

    &__summary-details {
        @apply flex my-3;
    }

    &__summary-img {
        @apply w-16 h-16 object-cover mr-3;
    }

    &__summary-value {
        @apply ml-auto;
    }

    &__summary-price {
        @apply mr-auto justify-end;

        span {
            @apply font-bold;
        }
    }
}
</style>
